import { render, staticRenderFns } from "./WarehouseManagementCreation.vue?vue&type=template&id=395d4a1a&scoped=true"
import script from "./WarehouseManagementCreation.vue?vue&type=script&lang=js"
export * from "./WarehouseManagementCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d4a1a",
  null
  
)

export default component.exports